import Vue from 'vue'
import Router from 'vue-router'

//page
//const Main = r => require.ensure([], () => r(require('../views/main/Main')))
import Index from  "@/views/index";

const Login = () => import( '@/views/login');
const Register = () => import( '@/views/register');
const Settlement = () => import( '@/views/settlement');

const UserCenterLayout = () => import( '@/views/usercenter/layout');
const BusinessUserCenterLayout = () => import( '@/views/usercenter/business_layout');
const AccountInfo = () => import( '@/views/usercenter/account_info');
const Notice = () => import( '@/views/usercenter/notice/index');
const NoticeDetail = () => import( '@/views/usercenter/notice/detail');
const Address = () => import( '@/views/usercenter/address');
const Attention = () => import( '@/views/usercenter/attention');
const Myfensi = () => import( '@/views/usercenter/myfensi');
const MarketingVideos = () => import( '@/views/usercenter/marketing/video');
const MarketingVideoDetail = () => import( '@/views/usercenter/marketing/detail');
const LogisticOrder = () => import( '@/views/usercenter/order/logistics_order');
const LogisticOrderinfo = () => import( '@/views/usercenter/order/logistics_order_info');
const TradeOrder = () => import( '@/views/usercenter/order/trade_order');
const TradeOrderInfo = () => import( '@/views/usercenter/order/trade_order_info');
const TransPortOrder = () => import( '@/views/usercenter/order/transport_order');
const TransPortOrderInfo = () => import( '@/views/usercenter/order/transport_order_info');
const Invoice = () => import( '@/views/usercenter/invoice/index');
const InvoiceInfo = () => import( '@/views/usercenter/invoice/info');
const Policy = () => import( '@/views/usercenter/policy/invoice');
const PolicyInfo = () => import( '@/views/usercenter/policy/info');

const Fabu = () => import( '@/views/usercenter/fabu/index');
const FabuInfo = () => import( '@/views/usercenter/fabu/info');

const PolicyMd = () => import( '@/views/usercenter/policyMendian/invoice');
const PolicyMdInfo = () => import( '@/views/usercenter/policyMendian/info');

const UpdatePwd = () => import( '@/views/usercenter/update_password');
const UpdateTel = () => import( '@/views/usercenter/update_phone');

const Todayxiaoshou = () => import( '@/views/usercenter/todayxiaoshou');
const Todayshougou = () => import( '@/views/usercenter/todayshougou');

const EnterpriseHome = () => import( '@/views/usercenter/enterprise/home');
const BusinessData = () => import( '@/views/usercenter/enterprise/business_data');
const BusData = () => import( '@/views/usercenter/enterprise/bus_data');
const InformationMg = () => import( '@/views/usercenter/enterprise/infomation_mg');
const Zhuxiao = () => import( '@/views/usercenter/enterprise/zhuxiao');

const TodayAcquisition = () => import( '@/views/usercenter/publish/today_acquisition');
const PublishTodayAcquisition = () => import( '@/views/usercenter/publish/add_acquisition');
const TodayAcquisitionInfo = () => import( '@/views/usercenter/publish/acquisition_info');
const TodaySales = () => import( '@/views/usercenter/publish/today_sales');
const PublishTodaySales = () => import( '@/views/usercenter/publish/add_sale');
const TodaysalesInfo = () => import( '@/views/usercenter/publish/sale_info');
const OpeningRenewalFee = () => import( '@/views/usercenter/opening_renewal_fee');
const Shoukuan = () => import( '@/views/usercenter/shoukuan');
const ShoukuanA = () => import( '@/views/usercenter/shoukuan_a');
const ShoukuanB = () => import( '@/views/usercenter/shoukuan_b');

const About = () => import( '@/views/usercenter/about');


const EnterpriseStore = () => import( '@/views/store');
const EnterpriseStoreList = () => import( '@/views/store_list');
const EnterpriseStoreInfo = () => import( '@/views/store_info');

const DomesticDemand = () => import( '@/views/domestic_demand');
const PublishDemand = () => import( '@/views/publish_demand');
const InternationalDemand = () => import( '@/views/International_demand');

const SupplyChain = () => import( '@/views/supply_chain');
const Notification = () => import( '@/views/notification');
const NotificationInfo = () => import( '@/views/notification_info');
const SaleVideos = () => import( '@/views/sale_videos');
const SaleVideoInfo = () => import( '@/views/sale_video_info');

const TodaySalePrice = () => import( '@/views/today_sale');
const Publishsale = () => import( '@/views/publish_sale');
const TodaySalePriceInfo = () => import( '@/views/today_sale_info');
const Publishacquisition = () => import( '@/views/publish_acquisition');

const TodayAcquisitionPrice = () => import( '@/views/today_acquisition');
const TodayAcquisitionPriceInfo = () => import( '@/views/today_acquisition_info');
const Deliver = () => import( '@/views/deliver');
const FreightTransport = () => import( '@/views/freight_transport');
const FreightTransportInfo = () => import( '@/views/freighttransport_info');
const Insurance = () => import( '@/views/insurance');
const SubmitOrder = () => import( '@/views/submit_order');
const PublishVideo = () => import( '@/views/publish_video');

const Stands = () => import( '@/views/stands');
const AddStand = () => import( '@/views/add_stand');

const PayOrder = () => import( '@/views/payorder');

const RetrievePassword = () => import( '@/views/retrieve_password');

const PublishGoodsSource = () => import( '@/views/publish_goods_source');
const DemandInfo = () => import( '@/views/demand_info');
const DemandList = () => import( '@/views/demand_list');


const Offer = () => import( '@/views/submit_offer_price');

const Report = () => import( '@/views/report');

const BasicLayout = () => import( '@/views/basice_layout');

const TextInfo = () => import( '@/views/text_info');

const FeedBack = () => import( '@/views/feedback_adv');

const Message = () => import( '@/views/message');

//other
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
  },
  {
    path: '/index',
    name: 'home',
    component: Index,
  },
  {
    path: '/message/:userId',
    name: 'message',
    component: Message,
  },{
    path: '/login',
    name: 'login',
    component: Login,
  }, {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/enterpriseStore',
    name: 'enterpriseStore',
    component: EnterpriseStore,
  },{
    path: '/domesticEmand/:type?',
    name: 'domesticEmand',
    component: DomesticDemand,
  }, 
  {
    path: '/enterpriseStore/list/:type',
    name: 'enterpriseStorelist',
    component: EnterpriseStoreList,
  },
  {
    path: '/',
    component: BasicLayout,
    redirect: '/index',
    children: [
      {
        path: '/report/:companyId',
        name: 'report',
        component: Report,
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: FeedBack,
      },
      {
        path: '/textinfo/:code',
        name: 'textinfo',
        component: TextInfo,
      }, {
        path: '/offer/:orderId',
        name: 'offer',
        component: Offer,
      }, {
        path: '/demandList',
        name: 'demandList',
        component: DemandList,
      }, {
        path: '/publishsale',
        name: 'publishsale',
        component: Publishsale,
      }, {
        path: '/demand/info/:id',
        name: 'demandinfo',
        component: DemandInfo,
      }, {
        path: '/retrievePassword',
        name: 'retrievePassword',
        component: RetrievePassword,
      }, {
        path: '/payorder/:orderNo/:orderType/:amount',
        name: 'payorder',
        component: PayOrder,
      }, {
        path: '/publishvideo',
        name: 'publishvideo',
        component: PublishVideo,
      }, {
        path: '/stands',
        name: 'stands',
        component: Stands,
      }, {
        path: '/addstand/:identityId',
        name: 'addstand',
        component: AddStand,
      }, {
        path: '/publishacquisition',
        name: 'publishacquisition',
        component: Publishacquisition,
      },
      {
        path: '/settlement',
        name: 'settlement',
        component: Settlement,
      },  {
        path: '/enterpriseStore/info/:id',
        name: 'enterpriseStoreinfo',
        component: EnterpriseStoreInfo,
      }, {
        path: '/demand/international',
        name: 'internationalDemand',
        component: InternationalDemand,
      }, {
        path: '/demand/publish/:type/:releaseType',
        name: 'publishdemand',
        component: PublishDemand,
      }, {
        path: '/supplyChain',
        name: 'supplyChain',
        component: SupplyChain,
      }, {
        path: '/notification',
        name: 'notification',
        component: Notification,
      }, {
        path: '/notificationinfo/:id',
        name: 'notificationinfo',
        component: NotificationInfo,
      }, {
        path: '/salevideos',
        name: 'salevideos',
        component: SaleVideos,
      }, {
        path: '/salevideoinfo/:videoId',
        name: 'saleVideoInfo',
        component: SaleVideoInfo,
      }, {
        path: '/todaysaleprice',
        name: 'todaySalePrice',
        component: TodaySalePrice,
      }, {
        path: '/todaysaleprice/info/:productId',
        name: 'todaysalepriceinfo',
        component: TodaySalePriceInfo,
      },
      {
        path: '/todayacquisitionprice',
        name: 'todayacquisitionprice',
        component: TodayAcquisitionPrice,
      },
      {
        path: '/todayacquisitionprice/info/:productId',
        name: 'todayacquisitionpriceinfo',
        component: TodayAcquisitionPriceInfo,
      },
      {
        path: '/publishgoodssource',
        name: 'publishgoodssource',
        component: PublishGoodsSource,
      },
      {
        path: '/deliver',
        name: 'deliver',
        component: Deliver,
        meta:{
          keepAlive:true,
        }
      }, {
        path: '/freighttransport',
        name: 'freighttransport',
        component: FreightTransport,
      }, {
        path: '/freighttransportinfo/:id',
        name: 'freighttransportinfo',
        component: FreightTransportInfo,
      }, {
        path: '/insurance',
        name: 'insurance',
        component: Insurance,
      }, {
        path: '/submitorder/:productId/:productType',
        name: 'submitorder',
        component: SubmitOrder,
      }
    ]
  },
  {
    path: '/',
    component: UserCenterLayout,
    redirect: '/accountInfo',
    children: [
      {
        path: 'accountInfo',
        component: AccountInfo
      },

      {
        path: 'businessdata',
        component: BusinessData
      },

      {
        path: 'notice',
        component: Notice
      },
      {
        path: 'notice/info/:id',
        component: NoticeDetail
      },
      {
        path: 'address',
        component: Address
      },
      {
        path: 'attention',
        component: Attention
      },
      {
        path: 'myfensi',
        component: Myfensi
      },
      {
        path: 'marketingvideos',
        component: MarketingVideos
      },
      {
        path: 'marketingvideoinfo/:id',
        component: MarketingVideoDetail
      },
      {
        path: 'invoice',
        component: Invoice
      },
      {
        path: 'invoiceinfo/:id',
        component: InvoiceInfo
      },
      {
        path: 'policyinvoice',
        component: Policy
      },
      {
        path: 'policyinvoiceinfo/:id',
        component: PolicyInfo
      },
      {
        path: 'fabu',
        component: Fabu
      },
      {
        path: 'fabuinfo/:id',
        component: FabuInfo
      },
      {
        path: 'policyMdinvoice',
        component: PolicyMd
      },
      {
        path: 'policyMdinvoiceinfo/:id',
        component: PolicyMdInfo
      },
      {
        path: 'account/updatepwd',
        component: UpdatePwd
      },
      {
        path: 'account/updatetel',
        component: UpdateTel
      },
      {
        path: 'about',
        component: About
      },
      {
        path: 'user/logisticorder',
        component: LogisticOrder
      },
      {
        path: 'user/logisticorderinfo/:orderno',
        component: LogisticOrderinfo
      },
      {
        path: 'user/tradeorder',
        component: TradeOrder
      },
      {
        path: 'user/tradeorderinfo/:orderno',
        component: TradeOrderInfo
      },
      {
        path: 'user/transportorder',
        component: TransPortOrder
      },
      {
        path: 'enterprise/transportorder',
        component: TransPortOrder
      },
      {
        path: 'user/transportorderinfo/:orderno',
        component: TransPortOrderInfo
      },
      {
        path: 'enterprise/home',
        component: EnterpriseHome
      },
      {
        path: 'todayxiaoshou',
        component: Todayxiaoshou
      },
      {
        path: 'todayshougou',
        component: Todayshougou
      },
      {
        path: 'enterprise/renew',
        component: OpeningRenewalFee
      },
      {
        path: 'shoukuana',
        component: ShoukuanA
      },
      {
        path: 'shoukuanb',
        component: ShoukuanB
      },
      {
        path: 'shoukuan',
        component: Shoukuan
      },
      {
        path: 'enterprise/transportorderinfo/:orderno',
        component: TransPortOrderInfo
      },
      {
        path: 'enterprise/infomationmgr',
        component: InformationMg
      },
      {
        path: 'enterprise/zhuxiao',
        component: Zhuxiao
      },
      {
        path: 'todaysales',
        component: TodaySales
      },
      {
        path: 'publishtodaysales',
        component: PublishTodaySales
      },
      {
        path: 'todaysalesinfo/:id',
        component: TodaysalesInfo
      },
      {
        path: 'todayacquisition',
        component: TodayAcquisition
      },
      {
        path: 'publishTodayAcquisition',
        component: PublishTodayAcquisition
      },
      {
        path: 'todayacquisitioninfo/:id',
        component: TodayAcquisitionInfo
      },

    ]
  },
  {
    path: '/',
    component: BusinessUserCenterLayout,
    redirect: '/enterprise',
    children: [
      {
        path: '/enterprise/busdata',
        component: BusData
      },
      // {
      //   path: 'enterprise/home',
      //   component: EnterpriseHome
      // },
      // {
      //   path: 'enterprise/renew',
      //   component: OpeningRenewalFee
      // },
      // {
      //   path: 'enterprise/shoukuana',
      //   component: ShoukuanA
      // },
      // {
      //   path: 'enterprise/shoukuanb',
      //   component: ShoukuanB
      // },
      // {
      //   path: 'enterprise/shoukuan',
      //   component: Shoukuan
      // },
      // {
      //   path: 'enterprise/infomationmgr',
      //   component: InformationMg
      // },
      // {
      //   path: 'enterprise/zhuxiao',
      //   component: Zhuxiao
      // },
      {
        path: 'enterprise/logisticorder',
        component: LogisticOrder
      },
      {
        path: 'enterprise/logisticorderinfo/:orderno',
        component: LogisticOrderinfo
      },
      {
        path: 'enterprise/tradeorder',
        component: TradeOrder
      },
      {
        path: 'enterprise/tradeorderinfo/:orderno',
        component: TradeOrderInfo
      },
      // {
      //   path: 'enterprise/transportorder',
      //   component: TransPortOrder
      // },
      // {
      //   path: 'enterprise/transportorderinfo/:orderno',
      //   component: TransPortOrderInfo
      // },
      // {
      //   path: 'todaysales',
      //   component: TodaySales
      // },
      // {
      //   path: 'publishtodaysales',
      //   component: PublishTodaySales
      // },
      // {
      //   path: 'todaysalesinfo/:id',
      //   component: TodaysalesInfo
      // },
      // {
      //   path: 'todayacquisition',
      //   component: TodayAcquisition
      // },
      // {
      //   path: 'publishTodayAcquisition',
      //   component: PublishTodayAcquisition
      // },
      // {
      //   path: 'todayacquisitioninfo/:id',
      //   component: TodayAcquisitionInfo
      // }
    ]
  }
]
export default new Router({
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js